module.exports = __webpack_public_path__ + "static/media/communify-admin-consent-true@3x.5bb16a4b.png";